const hasAccess = (privilegeName, customGuard = () => true) => {
  return (to, from, next) => {
    const canGo = customGuard(to, from, next);

    if (canGo && (!window.user.hasAuthority || window.user.hasAuthority(privilegeName))) {
      return next();
    }
    window.scEventBus.publish('GO_TO_UNAUTHORIZED_PAGE', {
      unauthorizedSupplier: true,
    });
  };
};

export default {
  hasAccess,
};
